import { createContext, useContext } from "react";
import type { ToolConfirmationDecision } from "@/api";

export interface ProposalContextValue {
  /** Someone the chat was shared with: cards are read-only. */
  readOnly: boolean;
  /** A reply is on its way: cards wait for it before acting. */
  busy: boolean;
  /** Sends the decision as my next message, whose text is the button's label; `onFailed` when it isn't sent. */
  onDecide?: (content: string, confirmation: ToolConfirmationDecision, onFailed: () => void) => void;
}

const ProposalContext = createContext<ProposalContextValue>({ readOnly: true, busy: false });

export const ProposalProvider = ProposalContext.Provider;
export const useProposalContext = () => useContext(ProposalContext);
